import App from 'app/App';
import 'core-js/stable';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/jsdom';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import 'regenerator-runtime/runtime';
import './react-chartjs-2-defaults';
import './react-table-defaults';
import './styles/index.css';
import React from 'react';

const render = () => {
    var AManifest = "manifest_app.json";
    var AHost = document.location.host.split(".")[0];

    if (AHost !== "app") {
        AManifest = `manifest_${AHost}.json`;
    }

    let AElement = document.createElement('link');
    AElement.setAttribute('rel', 'manifest');
    AElement.setAttribute('href', AManifest);
    document.getElementById('head-id').appendChild(AElement);

    ReactDOM.render(<App />, document.getElementById('root'));
};

window.onload = () => {
    render();
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA

//serviceWorker.register();
